import UserMetaInfo from './UserMetaInfo';

export default UserMetaInfo;
